import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import {
  FARM_NOTIFICATIONS_KEY,
  getNotificationKey,
  TOTAL_UNREAD_NOTIFICATION,
  USER_INFO_KEY,
} from 'common/constants/queryKeys'
import { useRecoilValue } from 'recoil'

import {
  getFarmNotifications,
  getNotificationList,
  getTotalUnreadNotification,
  getUserInfo,
} from '.'
import { selectedNotiFarmState } from '../stores/atom'

export const useUserInfo = () => {
  return useQuery({
    queryKey: USER_INFO_KEY,
    queryFn: async () => {
      const { data } = await getUserInfo()
      return data.data
    },
    staleTime: Infinity,
  })
}

export const useGetFarmNotifications = () => {
  return useQuery({
    queryKey: FARM_NOTIFICATIONS_KEY,
    queryFn: async () => {
      const { data } = await getFarmNotifications()
      return data.data
    },
    staleTime: 6000,
  })
}

export const useGetNotificationList = () => {
  const farmId = useRecoilValue(selectedNotiFarmState)
  const initParams = {
    params: {
      page: 1,
      pageSize: 10,
    },
  }

  return useInfiniteQuery({
    queryKey: getNotificationKey(farmId, initParams.params.page),
    queryFn: async ({ pageParam = initParams }) => {
      const { data } = await getNotificationList({
        farmId,
        pageSize: pageParam.params.pageSize,
        page: pageParam.params.page,
      })

      return {
        data: data.data.notifications,
        nextPage: data.data.has_next,
      }
    },
    getNextPageParam: (lastPage, _) => {
      if (lastPage.nextPage) {
        return {
          params: { ...initParams.params, page: lastPage.nextPage },
        }
      }
    },
    staleTime: Infinity,
    enabled: !!farmId,
  })
}

export const useGetTotalUnreadNotification = () => {
  return useQuery({
    queryKey: TOTAL_UNREAD_NOTIFICATION,
    queryFn: async () => {
      const { data } = await getTotalUnreadNotification()
      return data.data
    },
    staleTime: 6000,
  })
}
